module.exports = [
  {
    path: "/provider",
    name: "供应商中心",
    component: () => import("../../components/user/userMenu.vue"),
    meta: {
      requireAuth: true,
    },
    children: [
      {
        path: "accountInfo",
        name: "账户信息",
        component: () => import("../../components/provider/accountInfo.vue"),
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "accountBill",
        name: "账单管理",
        component: () => import("../../components/provider/accountBill.vue"),
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "downMateBill",
        name: "配货单下载",
        component: () => import("../../components/provider/downMateBill.vue"),
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "mateBill",
        name: "下载订单列表",
        component: () => import("../../components/provider/mateBill.vue"),
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "uploadBook",
        name: "上传书目",
        component: () => import("../../components/provider/uploadBook.vue"),
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "bookLog",
        name: "书目更新日志",
        component: () => import("../../components/provider/bookLog.vue"),
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "bookDown",
        name: "供应商书目下载",
        component: () => import("../../components/provider/bookDown.vue"),
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "eliminateKeywords",
        name: "屏蔽关键词",
        component: () => import("../../components/provider/eliminateKeywords.vue"),
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "supplierWarehouse",
        name: "供货商管理",
        component: () => import("../../components/provider/supplierWarehouse.vue"),
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "whProductStock",
        name: "库存管理",
        component: () => import("../../components/provider/whProductStock.vue"),
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "orderBack",
        name: "退货统计",
        component: () => import("../../components/provider/orderBack.vue"),
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "whOrderMain/:flag",
        name: "供应商订单",
        component: () => import("../../components/provider/whOrderMain.vue"),
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "deliverySummary",
        name: "供应商配送汇总",
        component: () => import("../../components/provider/deliverySummary.vue"),
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "whBatchOrder",
        name: "供应商批量下单",
        component:()=>import("../../components/order/whBatchOrder.vue"),
        meta: {
          requireAuth: true,
        },
      },
    ],
  },
];
